module.exports = __webpack_public_path__ + "static/img/logoimg1.9917d9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoimg1.jpg
// module id = xAgH
// module chunks = 10